module.exports = __webpack_public_path__ + "static/media/sprite.06d61f02.svg";